var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioCheckedCircleIconBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_65745)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.505859,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#805D57",
    stroke: "#805D57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0001 10.7858L3.2201 8.00576L2.27344 8.94576L6.0001 12.6724L14.0001 4.67242L13.0601 3.73242L6.0001 10.7858Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_65745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioCheckedCircleIconBrown);
export default __webpack_public_path__ + "static/media/radio_checked_circle_icon_brown.a1693a61.svg";
export { ForwardRef as ReactComponent };